export default __webpack_public_path__ + "static/media/Fera Balteus.a62795b2.jpg";